import Marionette from 'backbone.marionette';
import core_layouts, { TableLayout } from '../../../../core/layouts';
//import layouts from '../../layouts';
import pages, {
	AdvertisingView, ExtraMenu, LadderHeader, LadderTable, TippingCelebrityPopup
} from '../../views';
import components from '../../../../core/views/components';
import * as collections from '../../collections';
import { FinMatches } from '../../collections';
import { CompModel, CompShareModel } from '../../models';

import '../../styles/comps/comps-form.styl';
import '../../styles/comps/comps-table.styl';
import { sizes_for_big_ad } from '../../../../core/utils';
import { OverallLadder } from '../../../NRL_Fantasy/collections';

export default class CompsController extends Marionette.Object {
	/**
	 * Start method for each controller method
	 */
	start(data) {
		const
			rootView           = this.getOption( 'rootView' ),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			widgetsSidebar     = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView( {
				ad_id:   'competitions-ad-slot-1',
				ad_path: 'competitions',
				size:    [ 300, 250 ],
				pos: 2,
			} ),
			advertisingFooter  = new AdvertisingView( {
				ad_id:   'competitions-ad-slot-2',
				ad_path: 'competitions',
				size:    sizes_for_big_ad(),
				pos: 3,
			} );

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		if (data.top_content) {
			rightSidebarLayout.getRegion('top_content').show(data.top_content);
		}
		rightSidebarLayout.getRegion('content').show(data.content);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('top_ads_container').show(advertisingFooter);
	}

	/**
	 * Build league table layout
	 * @param data
	 * @returns {TableLayout}
	 */
	returnCompsTableLayout(data) {
		const
			loadMoreView = new components.LoadMoreView(),
			leaguesLayout = new TableLayout();

		leaguesLayout.getRegion('load_more').show(loadMoreView);

		if (data.header_page) {
			leaguesLayout.getRegion('header_page').show(data.header_page);
		}

		if(data.extra_menu) {
			leaguesLayout.getRegion('table_menu').show(data.extra_menu);
		}

		leaguesLayout.getRegion('table_body').show(data.table_body);

		return leaguesLayout;
	}

	/**
	 * Method for comps/my-comps
	 */
	myComps() {
		const
			table_data = {
				'table_body': new pages.MyCompsTableView({
					collection: new collections.Comps(),
					regeneration: new collections.RegenerateCompsCollection(),
					rounds: new collections.Rounds()
				}),
				'header_page': new pages.CompRegenerationBarView(),
				'extra_menu': new ExtraMenu()
			},
			start_data = {
				'content': this.returnCompsTableLayout(table_data)
			};

		this.start(start_data);
	}

	/**
	 * Method for comps/create
	 */
	compsCreate() {
		const rootView = this.getOption('rootView'),
			fullWidthLayout = new core_layouts.FullWidth(),
			advertisingFooter  = new AdvertisingView( {
				ad_id:   'competitions-ad-slot-2',
				ad_path: 'competitions',
				size:    sizes_for_big_ad(),
				pos: 3,
			}),
			start_data = new pages.CompsCreateView({
				model: new CompModel(),
				rounds: new collections.Rounds()
			});
		fullWidthLayout.getRegion( 'content' ).show( start_data );
		rootView.getRegion('main').show(fullWidthLayout);
		rootView.getRegion('top_ads_container').show(advertisingFooter);

	}

	/**
	 * Method for comps/:comp_id/congratulation
	 * @param league_id
	 */
	compCongratulation(league_id) {
		const start_data = {
			'content': new pages.CompCongratulationView({
				league_id,
				model: new CompModel(),
				show_header: true
			})
		};

		this.start(start_data);
	}

	/**
	 * Method for comps/join
	 */
	joinComps(code) {
		const
			table_data = {
				'header_page': new pages.JoinCompsFilterView(),
				'table_body': new pages.CompsJoinView({
					collection: new collections.Comps(),
					model: new CompModel(),
					rounds: new collections.Rounds(),
					code
				})
			},
			start_data = {
				'top_content': new pages.CompsJoinBar(),
				'content': this.returnCompsTableLayout(table_data)
			};

		this.start(start_data);
	}

	/**
	 * Method for comps/:league_id/manage
	 * @param league_id
	 */
	compSettings(league_id) {
		const
			table_data = {
				'table_body': new pages.CompsSettingsView({
					rounds: new collections.Rounds(),
					model: new CompModel(),
					league_id,
					teams: new collections.CompsTeams()
				})
			},
			celebrityPopup = new TippingCelebrityPopup({
				league_id,
				collection: new collections.TippingCelebrityTeams()
			}),
			start_data = {
				'content': this.returnCompsTableLayout(table_data)
			};

		this.start(start_data);
		this.getOption('rootView').getRegion('coach').show(celebrityPopup);
	}

	/**
	 * Method for comps/:league_id/invites
	 * @param league_id
	 */
	invitesAfterCreateComp(league_id) {
		this.compInvites(league_id, true);
	}

	/**
	 * Method for comps/:league_id/manage/invites
	 * @param league_id
	 * @param is_after_create
	 */
	compInvites(league_id, is_after_create) {
		const start_data = {
			'content': new pages.CompInvitesView({
				league_id,
				is_after_create: !!is_after_create,
				model: new CompModel(),
				share: new CompShareModel()
			})
		};

		this.start(start_data);
	}

	compsRegenerateList() {
		const
			table_data = {
				'header_page': new pages.RegenerationCompsHeaderView({
					step_number: 'step1'
				}),
				'table_body': new pages.RegenerateCompTableView({
					collection: new collections.RegenerateCompsCollection()
				})
			},
			start_data = {
				'content': this.returnCompsTableLayout(table_data)
			};

		this.start(start_data);
	}

	compRegenerate(league_id) {
		const
			table_data = {
				'header_page': new pages.RegenerationCompsHeaderView({
					step_number: 'step2'
				}),
				'table_body': new pages.RegenerationCompRestartView({
					league_id,
					model: new CompModel(),
					rounds: new collections.Rounds()
				})
			},
			start_data = {
				'content': this.returnCompsTableLayout(table_data)
			};

		this.start(start_data);
	}

	compRegenerateInvites(league_id, old_league_id) {
		const
			table_data = {
				'header_page': new pages.RegenerationCompsHeaderView({
					step_number: 'step3'
				}),
				'table_body': new pages.RegenerationCompInviteView({
					league_id,
					old_league_id,
					share: new CompShareModel(),
					model: new CompModel()
				})
			},
			start_data = {
				'content': this.returnCompsTableLayout(table_data)
			};

		this.start(start_data);
	}

	compRegenerateCongratulation(league_id) {
		const
			table_data = {
				'header_page': new pages.RegenerationCompsHeaderView({
					step_number: 'step4'
				}),
				'table_body': new pages.CompCongratulationView({
					league_id,
					model: new CompModel(),
					show_header: false
				})
			},
			start_data = {
				'content': this.returnCompsTableLayout(table_data)
			};

		this.start(start_data);
	}

	compLadder(league_id) {
		const
			model  = new CompModel(),
			rounds = new collections.Rounds();

		const
			rootView           = this.getOption( 'rootView' ),
			leaguesLayout      = new TableLayout(),
			tipping            = new collections.Tipping(),
			fullWidthLayout    = new core_layouts.FullWidth(),
			ladderHeader       = new LadderHeader( {
				league_id,
				model,
				tipping,
				rounds: rounds,
				fin_matches: new FinMatches(),
			} ),
			leagueRankingsView = new LadderTable( {
				league_id,
				model,
				tipping,
				overallLadder: new OverallLadder(),
				compTeams: new collections.CompsTeams(),
				comps:     new collections.CompsTips(),
				rounds:    rounds
			} ),
			advertisingTop  = new AdvertisingView( {
				ad_id:   'competitions-ad-slot-2',
				ad_path: 'leagues/ladder',
				size:    sizes_for_big_ad(),
				pos: 1,
			} ),
			loadMoreView = new components.LoadMoreView();

		leaguesLayout.getRegion( 'header_page' ).show( ladderHeader );
		leaguesLayout.getRegion( 'table_body' ).show( leagueRankingsView );
		leaguesLayout.getRegion('load_more').show(loadMoreView);

		fullWidthLayout.getRegion( 'content' ).show( leaguesLayout );

		rootView.getRegion( 'main' ).show( fullWidthLayout );
		rootView.getRegion( 'top_ads_container' ).show( advertisingTop );
	}
}